import { Checkbox, styled } from '@mui/material'

const BasicCheckbox = styled(Checkbox)({
	border: '1px solid #262626',
	borderRadius: '6px',
	width: '24px',
	height: '24px'
})

export default BasicCheckbox